import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";

export default class GameLeaderboardFilters implements FiltersInterface {
  public limit?: number = null;
  public page?: number = null;

  /**
   * @deprecated This property is no longer supported by the API and will be removed in a future version.
   * Please remove any usage of this property from your code.
   */
  public groupId?: string = null;

  constructor(filters: any) {
    this.limit = filters?.limit || null;
    this.page = filters?.page || null;

    if (filters?.groupId !== undefined) {
      console.warn(
        "Warning: groupId filter property is deprecated and no longer supported by the API. " +
          "This property will be removed in a future version. Please update your code accordingly."
      );
    }
  }

  public constructFiltersUrl?(): string {
    let url = "";

    if (this.limit) {
      url += "&";
      url += `limit=${this.limit}`;
    }
    if (this.page) {
      url += "&";
      url += `page=${this.page}`;
    }

    return url;
  }
}
